import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'open_with_faire-owf_application_continue_application-view';

/**
 * Track when a user continues the OWF application form. Optionally include where they were redirected from
 */
export function trackOpenWithFaireOwfApplicationContinueApplicationView(
  RedirectedFrom_string: string,
  isSignUp_string2: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { RedirectedFrom_string, isSignUp_string2 },
  });
}
